import {Component, Input} from '@angular/core';

/**
 * Use this component to trigger a default action when the primary button is clicked and provides a list of actions when the dropdown
 * button is clicked.
 */
@Component({
  selector: 'clo-buttons-split',
  templateUrl: './buttons-split.html',
  styleUrls: ['./button.scss'],
})
export class CloButtonsSplit {
  /**
   * String value for the ID of the drop down
   */
  @Input() dropdownID = 'dropDownMenuButton';

  /**
   * Objects for the drop down
   */
  @Input() objects: Object[];

  /**
   * String array of attributes for the object passed into the dropdown
   */
  @Input() attributes: string[];

  /**
   * String value for the error message
   */
  @Input() errorMessage = '';

  /**
   * Boolean value for whether the field is required
   *
   */
  @Input() required: boolean;

  /*
   * Method called when an option has been selected in the dropdown
   */
  selectOption(action) {
    alert('Call method to perform action when option was selected.');
  }
}
